export const environment = {
  production: false,
  sentry: 'https://aeae99ebc1e75d9c5daf6a56e12880cb@o446789.ingest.us.sentry.io/4509591831838720',
  name: 'Testing',
  baseUrl: 'https://testing.crowndesk.be',
  apiUrl: 'https://testing.crowndesk.be/api',
  auth0: {
    domain: 'staging-royalcrown.eu.auth0.com',
    clientId: 'Guf45pbswzpznbt083yqxyNcSoFCNGmO',
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: 'https://testing.api.royalcrown.be/',
      logoutUrl: window.location.origin,
    },
    useRefreshTokens: true,
    httpInterceptor: {
      allowedList: [
        {
          // Match any request that starts 'https://{yourDomain}/api/v2/' (note the asterisk)
          uri: `https://testing.crowndesk.be/api/*`,
          tokenOptions: {
            authorizationParams: {
              // The attached token should target this audience
              audience: 'https://testing.api.royalcrown.be/',
              scope: 'openid profile email offline_access',
            },
          },
        },
      ],
    },
  },
};
